import React from 'react';
import PropTypes from 'prop-types';
import { SmartSpotStatus } from 'components/SmartSpot';
import './VenueSmartSpotStatus.scss';

const VenueSmartSpotStatus = ({ isSmartspotEligible, smartspotEnabled }) => {
  if (!isSmartspotEligible) return null;

  return (
    <div className="venue-smartspot-status">
      <SmartSpotStatus isEnabled={smartspotEnabled} />
    </div>
  );
};

VenueSmartSpotStatus.propTypes = {
  isSmartspotEligible: PropTypes.bool,
  smartspotEnabled: PropTypes.bool,
};

export default VenueSmartSpotStatus;
